// Vuelta de una pasarela con redirect (MP) a `/pay`.
//
// El back_url que armamos ya trae query (`?pt=…&mp_return=1`) y MercadoPago le
// pega `?preapproval_id=…` sin mirar si ya había un `?`. El navegador lee eso
// como UN parámetro: `mp_return=1?preapproval_id=…`. Comparar `mp_return` con
// "1" daba falso y la vuelta se trataba como una visita nueva: la pantalla
// ofrecía pagar otra vez un plan ya cobrado. Se aceptan las dos formas (la
// correcta, por si MP lo arregla, y la que manda hoy).
//
// El `preapproval_id` es solo informativo: el backend NO lo usa para consultar,
// el preapproval sale de la suscripción (services/subscriptions/checkout).

export interface GatewayReturn {
  isReturn: boolean;
  preapprovalId: string | null;
}

export function parseGatewayReturn(params: URLSearchParams): GatewayReturn {
  const raw = params.get('mp_return');
  if (raw === null) return { isReturn: false, preapprovalId: null };
  const [flag, glued] = raw.split('?', 2);
  if (flag !== '1') return { isReturn: false, preapprovalId: null };
  const preapprovalId =
    params.get('preapproval_id') ?? (glued ? new URLSearchParams(glued).get('preapproval_id') : null);
  return { isReturn: true, preapprovalId: preapprovalId || null };
}
